module.exports = __webpack_public_path__ + "img/bigData.png";